import { render, staticRenderFns } from "./QuantificationLimits.vue?vue&type=template&id=6945923c&scoped=true"
import script from "./QuantificationLimits.vue?vue&type=script&lang=js"
export * from "./QuantificationLimits.vue?vue&type=script&lang=js"
import style0 from "./QuantificationLimits.vue?vue&type=style&index=0&id=6945923c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945923c",
  null
  
)

export default component.exports